import { render, staticRenderFns } from "./whatnowMessageCard.vue?vue&type=template&id=c65c077a&scoped=true"
import script from "./whatnowMessageCard.vue?vue&type=script&lang=js"
export * from "./whatnowMessageCard.vue?vue&type=script&lang=js"
import style0 from "./whatnowMessageCard.vue?vue&type=style&index=0&id=c65c077a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65c077a",
  null
  
)

export default component.exports